import React from 'react';

/**
 * StatusBadge - A component for displaying request status with appropriate styling
 * 
 * @param {Object} props
 * @param {string} props.status - The status to display
 * @returns {JSX.Element} A styled status badge
 */
const StatusBadge = ({ status, requestType }) => {
  const isOutbound = ['ship', 'pick_pack', 'kit_build'].includes(requestType);
  const isInboundManifest = requestType === 'inbound_manifest';

  const getStatusConfig = (status) => {
    switch (status) {
      case 'draft':
        return {
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          label: 'Draft'
        };
      case 'pending':
        return {
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          label: 'Pending Approval'
        };
      case 'approved':
        return {
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          label: isOutbound ? 'Pending Shipment' : 'Approved'
        };
      case 'pending_receive':
        return {
          bgColor: isInboundManifest ? 'bg-blue-100' : 'bg-purple-100',
          textColor: isInboundManifest ? 'text-blue-800' : 'text-purple-800',
          label: isInboundManifest ? 'Pending Receipt' : 'Scheduled'
        };
      case 'in_progress':
        return {
          bgColor: isInboundManifest ? 'bg-orange-100' : 'bg-indigo-100',
          textColor: isInboundManifest ? 'text-orange-800' : 'text-indigo-800',
          label: isInboundManifest ? 'Partially Received' : 'In Progress'
        };
      case 'completed':
        return {
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          label: isInboundManifest ? 'Complete' : 'Completed'
        };
      case 'cancelled':
        return {
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          label: 'Cancelled'
        };
      case 'rejected':
        return {
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          label: 'Rejected'
        };
      default:
        return {
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          label: status || 'Unknown'
        };
    }
  };

  const { bgColor, textColor, label } = getStatusConfig(status);

  return (
    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${bgColor} ${textColor}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
